import './holter/holterAnalysisReport/register';
import './holter/holterConfigure/register';
import './holter/holterConsult/register';
import './holter/holterConsultRequest/register';
import './holter/holterDiaryUpload/register';
import './holter/holterDirectExaminationRequest/register';
import './holter/holterExternalExaminationRequest/register';
import './holter/holterFollowUpConsultRequest/register';
import './holter/holterGrading/register';
import './holter/holterHomeExaminationRequest/register';
import './holter/holterReadOut/register';
import './holter/holterSecondRoundAnswer/register';
import './holter/holterSecondRoundQuestion/register';
import './holter/holterZorgdomeinExaminationRequest/register';
